import React from "react";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import AddStandardAttribute from "./AddStandardAttribute";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import AddIcon from "@mui/icons-material/Add";
import StandardAttribute_Actions from "../../../Actions/StandardAttribute_Actions";
import standardAttributeStores from "../../../Stores/StandardAttributeStores";
import StandardAttributeConstants from "../../../Constants/StandardAttributeConstants";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { useSelectedConfigActionContext } from "../../../Context/GlobalContext";
import commonUtils from "../../../helpers/commonUtils";
import ConfirmationPopUp from "../../MessageBox/ConfirmationPopUp";
import { AiFillInfoCircle } from "react-icons/ai";
import CommonSearchBar from "../../ReusableComponent/CommonSearchBar";
import { customizeFilter } from "../../FilterOptions/CustomizeFilter";
import { Button } from "@mui/material";
import CustomDataGrid from "../../ReusableComponent/DataGrid/CustomizeDataGrid";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import ImportComponent from "../../ReusableComponent/ImportComponent/importComponent";
import ImportAction from "../../../Actions/ImportAction";
import { PageHeader } from "../../MuiOverRideComponent/PageHeader";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
const StandardAttributeList = () => {
  const [standardAttributeList, setStandardAttributeList] = useState(null);
  const [resStandardAttributeList, setResStandardAttributeList] = useState([]);
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [standardAttributeDetails, setstandardAttributeDetails] = useState("");
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [queryResult, setQueryResult] = useState([]);
  const [attributeTypeList, setAttributeTypeList] = useState([]);
  const updateSelectedConfig = useSelectedConfigActionContext();

  const columns = [
    {
      field: "bezeichnung",
      headerName: localization.standardAttributeName,
      hideable: false,
      flex: 1,
    },
    {
      field: "actions",
      type: "actions",
      width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
    {
      field: "nameDisplay",
      headerName: localization.attributeNameDisplay,
      flex: 1,
    },
    { field: "type", headerName: localization.type, flex: 1 },
    { field: "einheit", headerName: localization.attributeUnit, flex: 1 },
    {
      field: "isMandatory",
      headerName: localization.isMandator,
      flex: 1,
      valueGetter: (params) =>
        params.row.isMandatory ? localization.yes : localization.no,
    },
    // { field: "code", headerName: "code" },
    // { field: "id", headerName: "ID" },
    // { field: "options", headerName: "options" },
    // { field: "queryId", headerName: "queryId" },
  ];

  const importIntial = {
    isOpen: false,
    headerTitle: localization.importAttribute,
    subHeaderTitle: localization.importAttributeTitle,
    handleClose: handleCloseImport,
    handleImport: handleImport,
    handleDownloadTemplate: handleDownloadTemplate,
  };
  const [openImport, setOpenImport] = useState(importIntial);
  //------------------------Get StandardAttribute start ----------------------
  const getStandardAttribute = () => {
    setGlobalSpinner(true);
    StandardAttribute_Actions.getStandardAttributes();
  };

  function getQueryList() {
    StandardAttribute_Actions.getQueries();
  }

  useEffect(() => {
    getStandardAttribute();

    getQueryList();
    function getStandardAttributeSuccess() {
      const res = standardAttributeStores.getstandardAttributeList();

      if (res.length > 0) {
        const tableData = res.map((item) => ({
          id: item.id,
          bezeichnung: item.bezeichnung,
          code: item.code,
          einheit: item.einheit,
          isMandatory: item.isMandatory,
          nameDisplay: item.nameDisplay,
          options: item.options,
          queryId: item.queryId,
          type: item.type,
        }));
        setStandardAttributeList(tableData);
        setResStandardAttributeList(tableData);
      } else {
        setStandardAttributeList([]);
        setResStandardAttributeList([]);
      }
      setGlobalSpinner(false);
      updateSelectedConfig("Standard Attribute");
    }

    function getStandardAttributeFailure() {
      const res = standardAttributeStores.getstandardAttributeList();
      setGlobalSpinner(false);
      updateSelectedConfig("Standard Attribute");
    }

    standardAttributeStores.addChangeListener(
      StandardAttributeConstants.GET_StandardAttribute_SUCCESS,
      getStandardAttributeSuccess,
    );

    standardAttributeStores.addChangeListener(
      StandardAttributeConstants.GET_StandardAttribute_FAILURE,
      getStandardAttributeFailure,
    );

    return () => {
      standardAttributeStores.removeChangeListener(
        StandardAttributeConstants.GET_StandardAttribute_SUCCESS,
        getStandardAttributeSuccess,
      );
      standardAttributeStores.addChangeListener(
        StandardAttributeConstants.GET_StandardAttribute_FAILURE,
        getStandardAttributeFailure,
      );
    };
  }, []);
  //------------------------Get StandardAttribute end ----------------------

  //------------------------Add or update StandardAttribute Logic start ----------------------
  useEffect(() => {
    function addOrUpdateStandardAttributeSuccess() {
      const res =
        standardAttributeStores.getAddorUpdateStandardAttributeResult();

      if (res) {
        commonUtils.hideModalPopUp("addStandardAttributeModalClose");
        toast.success(
          commonUtils.getIsEdit()
            ? localization.attributeeditedsuccessMessage
            : localization.attributeSavedsuccessMessage,
        );
      } else {
        toast.error(res);
      }
      getStandardAttribute();
    }

    function addOrUpdateStandardAttributeFailure() {
      const res =
        standardAttributeStores.getAddorUpdateStandardAttributeResult();

      toast.error(res);
      setGlobalSpinner(false);
    }

    standardAttributeStores.addChangeListener(
      StandardAttributeConstants.ADDORUPDATE_STANDARD_ATTRIBUTE_SUCCESS,
      addOrUpdateStandardAttributeSuccess,
    );

    standardAttributeStores.addChangeListener(
      StandardAttributeConstants.ADDORUPDATE_STANDARD_ATTRIBUTE_FAILURE,
      addOrUpdateStandardAttributeFailure,
    );

    return () => {
      standardAttributeStores.removeChangeListener(
        StandardAttributeConstants.ADDORUPDATE_STANDARD_ATTRIBUTE_SUCCESS,
        addOrUpdateStandardAttributeSuccess,
      );

      standardAttributeStores.removeChangeListener(
        StandardAttributeConstants.ADDORUPDATE_STANDARD_ATTRIBUTE_FAILURE,
        addOrUpdateStandardAttributeFailure,
      );
    };
  }, []);
  //------------------------Add StandardAttribute Button start ----------------------
  const handleAdd = () => {
    setstandardAttributeDetails("");
  };
  function RenderAddStandardAttribute() {
    return (
      <>
        <Button
          id="addStandardAttributeTest"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AddIcon />}
          data-toggle="modal"
          data-target="#addStandardAttribute"
        >
          {localization.add}
        </Button>
      </>
    );
  }
  //------------------------Add StandardAttribute Button end ----------------------

  //------------------------Edit StandardAttribute Button start ----------------------

  const handleEdit = (row) => {
    setstandardAttributeDetails(row);
  };
  function RenderEditButton(props) {
    const attribute = props.row;
    return (
      <>
        <Button
          id="editStandardAttributeTest"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AiOutlineEdit />}
          data-toggle="modal"
          data-target="#addStandardAttribute"
        >
          {localization.toolTipEdit}
        </Button>
      </>
    );
  }
  //------------------------Edit StandardAttribute Button end ----------------------

  //------------------------Add or update StandardAttribute end ----------------------

  //------------------------Delete StandardAttribute start ----------------------

  useEffect(() => {
    function deleteAttributeSuccess() {
      const res = standardAttributeStores.getDeletestandardAttribute();

      setStandardAttributeList(null);
      if (res.length === 0) {
        toast.success(localization.attributeDeletesuccessMessage);
      } else {
        res.forEach((item) => toast.error(item));
      }
      getStandardAttribute();
    }
    function deleteAttributeFailure() {
      const res = standardAttributeStores.getDeletestandardAttribute();

      setGlobalSpinner(false);
      toast.error(res);
    }

    standardAttributeStores.addChangeListener(
      StandardAttributeConstants.DELETE_ATTRIBUTE_SUCCESS,
      deleteAttributeSuccess,
    );
    standardAttributeStores.addChangeListener(
      StandardAttributeConstants.DELETE_ATTRIBUTE_FAILURE,
      deleteAttributeFailure,
    );
    return () => {
      standardAttributeStores.removeChangeListener(
        StandardAttributeConstants.DELETE_ATTRIBUTE_SUCCESS,
        deleteAttributeSuccess,
      );
      standardAttributeStores.removeChangeListener(
        StandardAttributeConstants.DELETE_ATTRIBUTE_FAILURE,
        deleteAttributeFailure,
      );
    };
  }, []);

  function deleteStandardAttributeCallback(standardAttributeIds) {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.deleteConfirmation);
    setCallbackData({
      attributeID: standardAttributeIds,
    });
    setEventType("DELETE_ATTIBUTE");
  }
  const handleDelete = (row) => {
    const _idList = [];
    if (Array.isArray(row)) {
      row.forEach((b) => _idList.push(b.id));
    } else {
      _idList.push(row.id);
    }
    deleteStandardAttributeCallback(_idList);
    commonUtils.hideModalPopUp("addStandardAttributeModalClose");
  };
  function RenderDeleteButton() {
    return (
      <>
        <Button
          id="deleteStandardAttributeTest"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AiOutlineDelete />}
        >
          {localization.delete}
        </Button>
      </>
    );
  }
  function handleImportClick() {
    setOpenImport((prev) => ({
      ...prev,
      isOpen: true,
    }));
  }
  function RenderImportButton() {
    return (
      <Button
        id="import"
        className="svgIcon cursorPoint"
        variant="outlined"
        startIcon={<UploadFileOutlinedIcon />}
        onClick={handleImportClick}
      >
        {localization.import}
      </Button>
    );
  }
  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_ATTIBUTE":
          setGlobalSpinner(true);
          const res = StandardAttribute_Actions.deleteAttribute(
            data.attributeID,
          );

          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };
  const closeEditStandardAttributePopUpCallback = () => {
    closePopUpCallback();
  };

  const closePopUpCallback = () => {
    setstandardAttributeDetails("");
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };
  //------------------------Delete StandardAttribute end ----------------------

  useEffect(() => {
    function getQuerySuccess() {
      const res = standardAttributeStores.getQueryListResult();

      if (res.length > 0) {
        setQueryResult(res);
      } else {
        setQueryResult([]);
      }
    }

    function getQueryFailure() {
      const res = standardAttributeStores.getQueryListResult();
    }

    standardAttributeStores.addChangeListener(
      StandardAttributeConstants.GET_QUERY_LIST_SUCCESS,
      getQuerySuccess,
    );

    standardAttributeStores.addChangeListener(
      StandardAttributeConstants.GET_QUERY_LIST_FAILURE,
      getQueryFailure,
    );

    return () => {
      standardAttributeStores.removeChangeListener(
        StandardAttributeConstants.GET_QUERY_LIST_SUCCESS,
        getQuerySuccess,
      );

      standardAttributeStores.removeChangeListener(
        StandardAttributeConstants.GET_QUERY_LIST_FAILURE,
        getQueryFailure,
      );
    };
  }, []);

  function clearProps() {
    setstandardAttributeDetails("");
  }

  function handleSearch(_enterText) {
    const res = customizeFilter(resStandardAttributeList, _enterText, [
      "code",
      "id",
      "options",
      "queryId",
    ]);
    setStandardAttributeList(res);
  }
  const operations = {
    RowOperationList: [
      {
        label: "Edit",
        component: <RenderEditButton />,
        onClick: handleEdit,
      },
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
    GridToolBarAction: [
      {
        label: "Add",
        component: <RenderAddStandardAttribute />,
        onClick: handleAdd,
      },
      {
        label: "Import",
        component: <RenderImportButton />,
        onClick: handleImportClick,
      },
    ],
    SelectedToolBar: [
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
  };

  function handleImport(seletedFile) {
    setGlobalSpinner(true);
    const obj = {
      ImportType: "Attribute",
      ImportFile: seletedFile,
    };
    ImportAction.uploadData(obj);
  }

  function handleCloseImport(_message) {
    if (_message === "success") {
      getStandardAttribute();
    }
    setOpenImport((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }

  function handleDownloadTemplate() {
    ImportAction.getTemplate({
      ImportType: "Attribute",
      UpdateTempalte: false,
    });
    setGlobalSpinner(true);
  }

  function getAction(params) {
    const _acionList = [];
    _acionList.push(
      <GridActionsCellItem
        label={localization.toolTipEdit}
        showInMenu
        onClick={() => handleEdit(params.row)}
        data-toggle="modal"
        data-target="#addStandardAttribute"
      />,
    );
    _acionList.push(
      <GridActionsCellItem
        label={localization.delete}
        showInMenu
        onClick={() => handleDelete(params.row)}
      />,
    );

    return _acionList;
  }
  return (
    <>
      <div className="w-100 h-100" id="content">
        {standardAttributeList && (
          <CustomDataGrid
            Title={
              localization.equSetting + " / " + localization.standardAttribute
            }
            columns={columns}
            rows={standardAttributeList}
            operations={operations}
            onAdd={handleAdd}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={[
              "bezeichnung",
              "nameDisplay",
              "type",
              "einheit",
              "isMandatory",
            ]}
            showCheckBox={true}
            gridTableHeight={"dataGridLarge"}
          />
        )}
      </div>
      <AddStandardAttribute
        standardAttributeDetails={standardAttributeDetails}
        attributeTypeList={attributeTypeList}
        queryResult={queryResult}
        clearProps={clearProps}
      />
      {openImport.isOpen && <ImportComponent data={openImport} />}
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
};

export default StandardAttributeList;
